import { startMeUp } from "#scripts/startscript.js";
import { ReadAimCookes } from "#scripts/cookie_control";
import deepmerge from "#scripts/tools/deepMerge";
import KeenTracking from "keen-tracking";

// Style
import "#src/style/style.scss";

window.AimCookies = ReadAimCookes();
window.fetchCounter = 0;
window.startTime = Date.now();

if (window.serverdata?.configMeta?.aim?.useKeenTracking === true) {
	document.addEventListener("readystatechange", (event) => {
		if (document.readyState === "complete") {
			const projectId = window.serverdata?.configMeta?.aim?.keenProjectId;
			const writeKey = window.serverdata?.configMeta?.aim?.keenWriteKey;
			const keenClient = new KeenTracking({
				projectId,
				writeKey,
				respectDoNotTrack: true,
			});

			// Custom storage functions
			function setSessionStorage (key, value) {
				sessionStorage.setItem(key, JSON.stringify(value));
			}

			function getSessionStorage (key) {
				const value = sessionStorage.getItem(key);
				return value ? JSON.parse(value) : null;
			}
			// Override Keen.io storage methods
			keenClient.setStorage = setSessionStorage;
			keenClient.getStorage = getSessionStorage;

			keenClient.setOptOut(sessionStorage.getItem("cookiePreference") === "rejected")

			keenClient.initAutoTracking({ recordPageViewsOnExit: true });
		}
	});
}

window.getUrlAttr = (attr) => new URL(window.location.href).searchParams.get(attr);
window.apiUrl = ["dev", "qa", "staging", "release", "preprod"].includes(window.AimCookies.RuntimeMode)
	? `https://prokom-aimcms-${window.AimCookies.RuntimeMode}.azurewebsites.net/api`
	: "https://prokom-aimcms.azurewebsites.net/api";
window.apiUrl = window.serverdata?.configMeta?.aim?.useLocalApiPath ? "/api/aim" : window.apiUrl;
if (window.AimCookies.RuntimeMode === "local") {
	window.apiUrl = "https://localhost:44351/api";
}
window.cmsUrl = "https://aim-admin.azurewebsites.net";

const urlParams = new URLSearchParams(window.location.search.replace("?", "").toLowerCase());
if (urlParams.get("runtimemode") !== null) {
	document.cookie = `RuntimeMode=${urlParams.get("runtimemode")}`;
}
if (urlParams.get("runtimedeveloper") !== null) {
	document.cookie = `RuntimeDeveloper=${urlParams.get("runtimedeveloper")}`;
}

if (window.location.href.match(/\?dev/gi)) {
	window.cmsUrl = "https://aim-admin-qa.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode !== "prod" && window.AimCookies.RuntimeMode !== undefined) {
	//merge serverdata.configMeta.aim and serverdata.configMeta.aim_dev
	const defaultAimConfig = window.serverdata?.configMeta?.aim;
	const devAimConfig = window.serverdata?.configMeta?.aim_dev;

	if (devAimConfig !== undefined) {
		window.serverdata.configMeta.aim = deepmerge(defaultAimConfig, devAimConfig);
	}
}

if (urlParams.get("devstyles") !== null) {
	document.cookie = `DevStyles=${urlParams.get("devstyles")}`;
	window.AimCookies.DevStyles = urlParams.get("devstyles");
}

if (window.AimCookies.RuntimeMode === "local") {
	console.log("%c Entering RuntimeMode: Localhost ", "color: #004085; background-color: #cce5ff; font-size: 15px;");
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "dev" && window.AimCookies.RuntimeMode !== "local") {
	console.log("%c Entering RuntimeMode: DEV ", "color: #004085; background-color: #cce5ff; font-size: 15px;");
	window.cmsUrl = "https://aim-admin-dev.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "qa") {
	console.log("%c Entering RuntimeMode: QA ", "color: #004085; background-color: #cce5ff; font-size: 15px;");
	window.cmsUrl = "https://aim-admin-qa.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "staging") {
	console.log("%c Entering RuntimeMode: STAGING ", "color: #856404; background-color: #fff3cd; font-size: 15px;");
	window.cmsUrl = "https://aim-admin-staging.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "release") {
	console.log("%c Entering RuntimeMode: RELEASE ", "color: #856404; background-color: #fff3cd; font-size: 15px;");
	window.cmsUrl = "https://aim-admin-release.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "preprod") {
	console.log("%c Entering RuntimeMode: PREPROD ", "color: #856404; background-color: #fff3cd; font-size: 15px;");
	window.cmsUrl = "https://aim-admin-release.azurewebsites.net";
	window.dev = true;
}

if (window.AimCookies.RuntimeMode === "prod") {
	console.log("%c Entering RuntimeMode: PROD ", "color: #856404; background-color: #fff3cd; font-size: 15px;");
	window.cmsUrl = "https://aim-admin.azurewebsites.net";
	window.dev = true;
}

// window.contentID = "";
window.contentSubscription = "";
window.translation = {};

document.addEventListener("DOMContentLoaded", (event) => {
	if (window.serverdata !== undefined) {
		const meta = JSON.parse(window.serverdata.defaultConfig.result.applications[0].metaData);
		const defaultTranslation = meta.translation;
		const customTranslation = window.serverdata.configMeta.translation ? window.serverdata.configMeta.translation : {};
		window.translation = deepmerge(defaultTranslation, customTranslation);
		startMeUp(event);
	}
});
